// The global banner the customer shell shows while the platform operator has
// dispatch paused. The flag rides `/api/me`, so the shell's shared poll picks
// up a pause or a resume without a reload.
// See ADR-0039 §4.

/** The sentence the banner shows; the same one every run-starting verb is refused with. */
export const DISPATCH_PAUSED_MESSAGE = "Runs are paused for maintenance";

/**
 * Renders the dispatch-paused banner when `paused` is set and nothing
 * otherwise. The customer app entry renders it above every screen.
 */
export function MaintenanceBanner({ paused }: { paused: boolean }): JSX.Element | null {
  if (!paused) return null;
  return (
    <div className="banner warn" role="status" data-testid="maintenance-banner">
      {DISPATCH_PAUSED_MESSAGE}
    </div>
  );
}
